import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { UserDropdown } from "CommonDropdowns";

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  const [userValue, setUserValue] = useState(null);

  // Effect to clear the manager dropdown when filters are cleared from outside
  useEffect(() => {
    if (!extraFiltersState.values.manager_id) {
      setUserValue(null);
    }
  }, [extraFiltersState.values.manager_id]);

  const handleClear = () => {
    setExtraFiltersState({ values: {} });
  };

  const handleManagerChange = (selected) => {
    setUserValue(selected);
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, manager_id: selected ? selected.value : "" },
    }));
  };

  const handleSearch = () => {
    onFilter();
  };

  const handleChange = (event) => {
    event.persist();
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, [event.target.name]: event.target.value },
    }));
  };

  return (
    <div className="filters-flex pb-3">
      <Row className="align-items-end">
        <Col lg={4}>
          <Form.Group className="mb-3">
            <Form.Label className="label-input">Program</Form.Label>
            <Form.Control
              type="text"
              name="program_name"
              placeholder="Type a program name"
              className="input-field"
              onChange={handleChange}
              value={extraFiltersState.values.program_name || ""}
            />
          </Form.Group>
        </Col>
        <Col lg={4}>
          <UserDropdown
            isMulti={false}
            selectedId={extraFiltersState.values.manager_id || ""}
            userValue={userValue}
            setUserValue={setUserValue}
            userOnChange={handleManagerChange}
            placeholder="Select Manager"
            label="Manager"
          />
        </Col>
        <Col lg={2}>
          <Form.Group className="mb-3">
            <Form.Label className="label-input">Status</Form.Label>
            <Form.Select
              name="is_active"
              className="input-field"
              value={extraFiltersState.values.is_active || ""}
              onChange={handleChange}
            >
              <option value="">All</option>
              <option value="y">Active</option>
              <option value="n">Inactive</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col lg={2}>
          <div className="d-flex align-items-end gap-2 mb-3">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn"
              style={{ minWidth: 100 }}
            >
              <img
                src="/assets/images/search-white.svg"
                alt=""
                className="me-2"
              />{" "}
              Search
            </button>
            <button
              type="button"
              onClick={handleClear}
              className="btn btn-secondary"
              style={{ minWidth: 80 }}
            >
              Clear
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Filter;